import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import Button from '../../atoms/Button';
import Text from '../../atoms/Text';
import config from '../../../config';

const Container = styled(Flex)`
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`;

const getScannerSrc = (appType) => {
  let filename = 'stampScanner_tw';
  if (appType === 'kolour_yl') {
    filename = 'stampScanner_yl';
  }
  return `${config.publicUrl}/${filename}.html`;
};

const StampScanner = ({ onScanned, onClose, onError, appType, ...props }) => {
  const frameSize = Math.floor(Math.min(window.innerHeight, window.innerWidth) * 0.9);
  useEffect(() => {
    const messageListener = (e) => {
      try {
        const { data: { type, value } } = e;
        switch (type) {
          case 'stamp_detected': {
            onScanned(value);
            break;
          }
          case 'camera-error': {
            throw new Error(type);
          }
          default: {
            break;
          }
        }
      } catch (err) {
        onError(err);
      }
    }
    window.addEventListener('message', messageListener);
    return (() => {
      window.removeEventListener('message', messageListener)
    });
  }, [onScanned, onError]);
  return (
    <Container {...props}>
      <iframe src={getScannerSrc(appType)} title="Stamp Scanner" width={frameSize} height={frameSize} scrolling="no" />
      <Flex mt="1rem">
        <Button onClick={onClose} color="tertiary">
          <Text palette="secondary">Close</Text>
        </Button>
      </Flex>
    </Container>
  );
};

StampScanner.propTypes = {
  onScanned: PropTypes.func,
  onClose: PropTypes.func,
  onError: PropTypes.func,
  appType: PropTypes.string,
};

StampScanner.defaultProps = {
  onScanned: () => {},
  onClose: () => {},
  onError: () => {},
  appType: 'kolour_tw',
};

export default StampScanner;
